"use strict";

import {find,hasClass,addClass,removeClass,toggleClass,on,closest,findIn} from "@c0necto/elements-dom-utils";
import {onFind} from "@c0necto/elements-init-modules-in-scope";

export function init () {




    onFind('.js-accommodation-overview__map-toggle', function (mapToggle) {

        let accoOverview = closest('.js-accommodation-overview',mapToggle),
            accoOverviewCanvas = findIn('.js-ajax-form-map-leaflet__canvas', accoOverview),
            accoOverviewMap = findIn('.js-accommodation-overview__map', accoOverview),
            accoOverviewList = findIn('.js-accommodation-overview__list', accoOverview);


        const clickHandler = (evt, mapToggle) => {
            if(matchMedia('(min-width: 768px)').matches){
                if(hasClass('is-fullscreen', mapToggle)){
                    removeClass('is-fullscreen',mapToggle);
                    addClass('col-md-7',accoOverviewMap);
                    removeClass('col-12',accoOverviewMap);
                    removeClass('d-none',accoOverviewList);
                }else{
                    addClass('is-fullscreen',mapToggle);
                    removeClass('col-md-7',accoOverviewMap);
                    addClass('col-12',accoOverviewMap);
                    addClass('d-none',accoOverviewList);
                }

                toggleClass('is-fullscreen',accoOverviewCanvas);

            }else{
                toggleClass('is-fullscreen',accoOverviewCanvas);
            }

        };

        on('click', (evt) => clickHandler(evt, mapToggle), mapToggle);

    });


     onFind('.js-accommodation-filter__toggle-btn', function (moreFilterToggle) {

         let filterSearch = find('.js-accommodation-filter__toggle-search');

         const clickHandler = (evt, moreFilterToggle) => {
             if(hasClass('collapsed', moreFilterToggle)){
                 removeClass('hide',filterSearch);
             }else{
                 addClass('hide',filterSearch);
             }
         };

         on('click', (evt) => clickHandler(evt, moreFilterToggle), moreFilterToggle);

     });

}